<template>
  <v-card class="mt-3" outlined>
    <v-card-title class="text-subtitle-1 font-weight-bold text-truncate d-inline-block">
      Критерии оценивания
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-3">
      <v-row no-gutters>
        <v-scroll-y-transition
            class="py-0"
            tag="div"
            leave-absolute
            style="width: 100%"
            group
        >
          <v-col cols="12" v-for="(level, i) in levels" :key="i">
            <v-card min-height="100%" outlined>
              <v-card-title class="text-subtitle-1 font-weight-bold text-truncate d-inline-block py-2">
                {{titleCardLevel(level.name)}}
              </v-card-title>
              <v-divider/>
              <v-card-text>
                <achievement-kind-level-text-field :achievementLevel="level" :index="i"/>
                <section-edit-subunit v-if="level.score === 0" :levels="level" :idx-level="i" class="mt-3"/>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-btn dense
                       class="px-2"
                       :color="$store.state.achievement.btn_color"
                       @click="deleteLevelWithAchievement(i)">
                  <v-icon small color="white">fa fa-trash</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-scroll-y-transition>
        <v-col cols="12" style="height: 100%">
          <add-card :body_text="'Добавить уровень достижения'"
                    :min_height="'54px'"
                    class="mt-3"
                    @add="pushLevelWithAchievement({name: '', score: 0, subunits: []})"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import AddCard from "../../Cards/AddCard";
import SectionEditSubunit from "./SectionEditSubunit";
import AchievementKindLevelTextField from "../FormAdminAchievementKind/AchievementKindLevelTextField";

export default {
  name: "SectionEditLevel",

  components: {
    AddCard,
    SectionEditSubunit,
    AchievementKindLevelTextField,
  },

  data() {
    return {

      rules_points_text: [
        (v) => !!v || "Это поле обязательно к заполнению",
        // (v) => v.length < 4 || "Допускаются только 3 символа",
      ]
    };
  },

  computed: {
    ...mapState({
      levels: state => state.achievement_kind.achievement.levels,
    }),
  },

  methods: {
    ...mapMutations({
      pushLevelWithAchievement: 'achievement_kind/pushLevelWithAchievement',
      deleteLevelWithAchievement: 'achievement_kind/deleteLevelWithAchievement',
    }),

    titleCardLevel(name) {
      if (!name.length) return "Название уровня"
      else return name
    },

  },
}
</script>

<style scoped>

</style>